'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = exports.ListContainer = exports.InputRight = exports.Placeholder = exports.SelectInput = exports.InputContainer = exports.SelectWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border: 1px solid ', ';\n  cursor: pointer;\n  display: block;\n  font: inherit;\n  outline: 0;\n  padding: 0;\n  width: 100%;\n  display: flex;\n'], ['\n  background-color: ', ';\n  border: 1px solid ', ';\n  cursor: pointer;\n  display: block;\n  font: inherit;\n  outline: 0;\n  padding: 0;\n  width: 100%;\n  display: flex;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 4px 46px 4px 16px;\n  min-height: 39px;\n  text-align: left;\n  width: 100%;\n'], ['\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 4px 46px 4px 16px;\n  min-height: 39px;\n  text-align: left;\n  width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  line-height: 1;\n  color: #aaaaaa;\n'], ['\n  line-height: 1;\n  color: #aaaaaa;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n // display: flex;\n // align-self: center;\n //  justify-content: center;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  bottom: 0;\n  width: ', ';\n  cursor: pointer;\n  text-align: right;\n'], ['\n // display: flex;\n // align-self: center;\n //  justify-content: center;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  bottom: 0;\n  width: ', ';\n  cursor: pointer;\n  text-align: right;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  margin: 0;\n  padding: 0;\n  max-height: ', ';\n  overflow: auto;\n  color: ', ';\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-top: none;\n  list-style: none;\n  box-shadow: ', ';\n  -ms-overflow-style: none;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  -webkit-overflow-scrolling: touch;\n'], ['\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  margin: 0;\n  padding: 0;\n  max-height: ', ';\n  overflow: auto;\n  color: ', ';\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-top: none;\n  list-style: none;\n  box-shadow: ', ';\n  -ms-overflow-style: none;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  -webkit-overflow-scrolling: touch;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  cursor: pointer;\n  padding: 8px 16px;\n  color: ', ';\n  transition: background-color .3s;\n\n  &:hover {\n    background-color: ', ';\n  }\n'], ['\n  cursor: pointer;\n  padding: 8px 16px;\n  color: ', ';\n  transition: background-color .3s;\n\n  &:hover {\n    background-color: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SelectWrapper = exports.SelectWrapper = _styledComponents2.default.div(_templateObject);

SelectWrapper.displayName = 'SelectWrapper';
var InputContainer = exports.InputContainer = _styledComponents2.default.button(_templateObject2, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.color.border;
});

InputContainer.displayName = 'InputContainer';
var SelectInput = exports.SelectInput = _styledComponents2.default.div(_templateObject3);

SelectInput.displayName = 'SelectInput';
var Placeholder = exports.Placeholder = _styledComponents2.default.div(_templateObject4);

Placeholder.displayName = 'Placeholder';
var InputRight = exports.InputRight = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.hasClear ? '60px' : '30px';
});

InputRight.displayName = 'InputRight';
var ListContainer = exports.ListContainer = _styledComponents2.default.ul(_templateObject6, function (props) {
  return props.maxHeight;
}, function (props) {
  return props.theme.color.base2;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.color.border;
}, function (props) {
  return props.theme.boxShadow['1'];
});

ListContainer.displayName = 'ListContainer';
var ListItem = exports.ListItem = _styledComponents2.default.li(_templateObject7, function (props) {
  return props.active && props.theme.color.secondary;
}, function (props) {
  return (0, _helpers.darkenColor)(props.theme.color.white, 5);
});
ListItem.displayName = 'ListItem';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-select/styles.js
// module id = 1288
// module chunks = 4